import InputBase from "@mui/material/InputBase"
import { styled } from '@mui/material/styles'
import { BORDERRADIUS as borderRadius } from "@fedsim/constants"

export const GameSelect = styled(InputBase)(({ theme, size }) => ({
    'label + &': {
        marginTop: theme.spacing(3)
    },
    '& .MuiInputBase-input': {
        borderRadius,
        color: '#000',
        position: 'relative',
        backgroundColor: '#fff',
        border: '1px solid #ced4da',
        fontSize: size === 'small' ? 14 : 17, // Set font size based on props.size
        padding: size === 'small' ? '4px 8px' : '6px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: ['Arial', 'sans-serif'].join(','),
        '&:focus': {
            borderRadius,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)'
        }
    }
}))

export default GameSelect
